import { CommandContribution } from '@patsnap/tahiti-core';
import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { TrialEndDialogCommandHandler } from './services/commands/trial-end-dialog.commands';

/**
 * TrialEnd 功能模块
 * 提供试用结束对话框命令
 */
export const trialEndModule = (bind: interfaces.Bind) => {
    bind(CommandContribution).to(TrialEndDialogCommandHandler);
};
